import { render, staticRenderFns } from "./ShowInternalDonation.vue?vue&type=template&id=b71d44d0&"
import script from "./ShowInternalDonation.vue?vue&type=script&lang=js&"
export * from "./ShowInternalDonation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports